const onScrollEnds = (callback, t = 250) => {
  window.removeEventListener('scroll', checkScrolling);
  //
  let scrolling;

  window.addEventListener('scroll', checkScrolling);

  function checkScrolling() {
    clearTimeout(scrolling);

    scrolling = setTimeout(() => {
      callback();
      window.removeEventListener('scroll', checkScrolling);
    }, t);
  }
};

export default onScrollEnds;
